"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloudflareHttp = exports.Cloudflare = void 0;
var helpers_1 = require("./helpers");
var http_1 = require("./http");
var Cloudflare;
(function (Cloudflare) {
    Cloudflare[Cloudflare["InternalServerError"] = 500] = "InternalServerError";
    Cloudflare[Cloudflare["BadGateway"] = 502] = "BadGateway";
    Cloudflare[Cloudflare["ServiceTemporarilyAvailable"] = 503] = "ServiceTemporarilyAvailable";
    Cloudflare[Cloudflare["GatewayTimeout"] = 504] = "GatewayTimeout";
    Cloudflare[Cloudflare["UnknownError"] = 520] = "UnknownError";
    Cloudflare[Cloudflare["WebServerIsDown"] = 521] = "WebServerIsDown";
    Cloudflare[Cloudflare["ConnectionTimedOut"] = 522] = "ConnectionTimedOut";
    Cloudflare[Cloudflare["OriginIsUnreachable"] = 523] = "OriginIsUnreachable";
    Cloudflare[Cloudflare["ATimeoutOccurred"] = 524] = "ATimeoutOccurred";
    Cloudflare[Cloudflare["SslHandshakeFailed"] = 525] = "SslHandshakeFailed";
    Cloudflare[Cloudflare["InvalidSslCertificate"] = 526] = "InvalidSslCertificate";
    Cloudflare[Cloudflare["RailgunError"] = 527] = "RailgunError";
    Cloudflare[Cloudflare["DnsError"] = 530] = "DnsError";
    Cloudflare[Cloudflare["DNSProhibitedIP"] = 1000] = "DNSProhibitedIP";
    Cloudflare[Cloudflare["DNSResolutionError"] = 1001] = "DNSResolutionError";
    Cloudflare[Cloudflare["Restricted"] = 1002] = "Restricted";
    Cloudflare[Cloudflare["DirectIPAccessNotAllowed"] = 1003] = "DirectIPAccessNotAllowed";
    Cloudflare[Cloudflare["HostNotConfigured"] = 1004] = "HostNotConfigured";
    Cloudflare[Cloudflare["AccessDeniedIPBanned"] = 1006] = "AccessDeniedIPBanned";
    Cloudflare[Cloudflare["AccessDeniedIPISBanned"] = 1007] = "AccessDeniedIPISBanned";
    Cloudflare[Cloudflare["AccessDeniedIPHasBeenBanned"] = 1008] = "AccessDeniedIPHasBeenBanned";
    Cloudflare[Cloudflare["WebsiteOwnerBannedBrowserAccess"] = 1010] = "WebsiteOwnerBannedBrowserAccess";
    Cloudflare[Cloudflare["AccessDeniedHotlinkingDenied"] = 1011] = "AccessDeniedHotlinkingDenied";
    Cloudflare[Cloudflare["AccessDenied"] = 1012] = "AccessDenied";
    Cloudflare[Cloudflare["HTTPHostnameTLSHostnameMismatch"] = 1013] = "HTTPHostnameTLSHostnameMismatch";
    Cloudflare[Cloudflare["CrossUserBanned"] = 1014] = "CrossUserBanned";
    Cloudflare[Cloudflare["RateLimited"] = 1015] = "RateLimited";
    Cloudflare[Cloudflare["OriginDNSError"] = 1016] = "OriginDNSError";
    Cloudflare[Cloudflare["HostNotFound"] = 1018] = "HostNotFound";
    Cloudflare[Cloudflare["ComputeServerError"] = 1019] = "ComputeServerError";
    Cloudflare[Cloudflare["Accessdenied"] = 1020] = "Accessdenied";
    Cloudflare[Cloudflare["CheckBackLater"] = 1025] = "CheckBackLater";
    Cloudflare[Cloudflare["RenderingError"] = 1101] = "RenderingError";
    Cloudflare[Cloudflare["RenderError"] = 1102] = "RenderError";
    Cloudflare[Cloudflare["CacheConnectionLimit"] = 1200] = "CacheConnectionLimit";
})(Cloudflare = exports.Cloudflare || (exports.Cloudflare = {}));
exports.CloudflareHttp = helpers_1.mergeEnums(http_1.Http, Cloudflare);
//# sourceMappingURL=cloudflare.js.map